import React, { useState } from 'react'
import LiveSelect from 'live/components/forms/ui/select';
import { VIEW_MAPS_MARKERS, VIEW_MAPS_POLYLINE } from '../../view-utils';
import { getExtensionsQualifier } from '../../api/google-integration';
import { useEffect } from 'react';

interface IProps{
  extensionQualifier: string,
  zoom: number,
  view: number
  onChange: any
  positionsReportId: number,
  tripsReportId: number
}

const ConfigDefault = ({zoom, view, onChange, extensionQualifier, positionsReportId, tripsReportId}: IProps) => {

    const options = [
      { value: VIEW_MAPS_POLYLINE, label: 'Maps Polyline' },
      { value: VIEW_MAPS_MARKERS, label: 'Maps Markers' }
    ]
    
    const [selected, setSelected] = useState(options.find(ele => ele.value === view));
    const [extensionsQualifiers, setExtensionsQualifiers] = useState();
    const [selectedExtensionsQualifiers, setSelectedExtensionsQualifiers] = useState(extensionQualifier);

    useEffect(() => {
      getExtensionsQualifier().then(response => {
          setExtensionsQualifiers(response.data.map(ele => ({ value: ele, label: ele })));
      });
    }, [])


    return (
       <>
          <div>
                <label>Integração Google Maps</label>
                <LiveSelect
                    placeholder="Choose the integration"
                    options={extensionsQualifiers}
                    value={selectedExtensionsQualifiers}
                    onChange={(value, obj) => {
                        onChange('extensionQualifier', value)
                        setSelectedExtensionsQualifiers(obj);
                    }}
                />
            </div>

          <div>
            <label>View</label>
            <LiveSelect
              placeholder="Choose the view"
              options={options}
              value={selected}
              onChange={(value, obj) => {
                  onChange('view', value)
                  setSelected(obj);
              }}
            />
          </div>

          <div>
              <label>Zoom</label>
              <input type="number" min={1} max={25} value={zoom} onChange={({ target }) => onChange('zoom', target.value)}/>
          </div>

          <div style={{marginTop: '20px'}}>
              <label>ID Dashboard Relatório de Posições</label>
              <input type="number"  value={positionsReportId} onChange={({ target }) => onChange('positionsReportId', target.value)}/>
          </div>

          <div style={{marginTop: '20px'}}>
              <label>ID Dashboard Relatório de Viagens</label>
              <input type="number"  value={tripsReportId} onChange={({ target }) => onChange('tripsReportId', target.value)}/>
          </div>

       </>
    );
}

export default ConfigDefault;
